// src/components/HomePage/Section1/index.js
import React from 'react';
import {
  Container,
  ContentSection,
  Title,
  Subtitle,
  ButtonContainer,
  ButtonPrimary,
  ButtonSecondary,
  RatingSection,
  RatingStars,
  RatingText,
  ImageFrame,
  RotatedFlag
} from './styles';
import frame from '../../../images/frame.png';
import bandeiras from '../../../images/bandeiras.png';

const Section1 = () => {
  return (
    <Container id="home">
      <ContentSection>
        <span style={{ color: '#272643', fontSize: '1.2rem', marginTop: '5rem',  textAlign: 'left'}}>
          IA EDUCACIONAL{"\u00A0"}{"\u00A0"}
          <RotatedFlag src={bandeiras} alt="Bandeiras" />
        </span>
        <Title>
          Aprenda Inglês de Verdade – Direto no Seu WhatsApp, Sem Enrolação!
        </Title>
        <Subtitle>
          Desafios diários para atividades reais com um professor de IA. Aprenda no seu tempo, mesmo sem tempo.
        </Subtitle>
        
        <ButtonContainer>
          <ButtonPrimary>Quero Aprender Agora</ButtonPrimary>
          <ButtonSecondary>Teste 7 Dias Grátis</ButtonSecondary>
        </ButtonContainer>

        <RatingSection>
          <RatingStars>★★★★★</RatingStars>
          <RatingText>
            Recomendamos fortemente a qualquer pessoa que esteja buscando melhorar sua proficiência no idioma.
            <br /> <br />
            Nota 5/5 – <span style={{ color: '#4D4D4D', fontSize: '0.8rem' }}>
            em mais de 60 avaliações</span>
          </RatingText>
        </RatingSection>
      </ContentSection>
      
      <ImageFrame src={frame} alt="WhatsApp Interface" />
    </Container>
  );
};

export default Section1;
